(() => {
  if (window.SangoProductCardGalleryLoaded) return;
  window.SangoProductCardGalleryLoaded = true;

  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.sangoGalleryInitialized === 'true') return;

    const viewport = gallery.querySelector('[data-sango-gallery-viewport]');
    const slides = Array.from(
      gallery.querySelectorAll('.sango-card-gallery__slide')
    );

    const prevButton = gallery.querySelector('[data-sango-gallery-prev]');
    const nextButton = gallery.querySelector('[data-sango-gallery-next]');
    const dots = Array.from(
      gallery.querySelectorAll('[data-sango-gallery-dot]')
    );

    if (!viewport || slides.length < 2) {
      gallery.dataset.sangoGalleryInitialized = 'true';
      return;
    }

    gallery.dataset.sangoGalleryInitialized = 'true';

    let currentIndex = 0;
    let scrollTimer = null;

    let pointerStartX = 0;
    let pointerStartY = 0;
    let didDrag = false;

    const updateButtons = () => {
      if (prevButton) {
        prevButton.disabled = currentIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = currentIndex >= slides.length - 1;
      }
    };
    
    const updatePagination = () => {
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const hydrateSlide = (index, priority = 'low') => {
      const slide = slides[index];
      if (!slide) return;

      const image = slide.querySelector('img[data-sango-src]');
      if (!image) return;

      // Once a carousel image is intentionally warmed, do not leave it lazy.
      // Hidden horizontal slides can otherwise wait until after the animation.
      image.loading = 'eager';
      image.fetchPriority = priority;

      if (image.dataset.sangoSrcset) {
        image.srcset = image.dataset.sangoSrcset;
      }
      image.src = image.dataset.sangoSrc;
      image.removeAttribute('data-sango-src');
      image.removeAttribute('data-sango-srcset');
    };

    const warmSlidesAround = (index) => {
      hydrateSlide(index - 1, 'low');
      hydrateSlide(index + 1, 'low');
      hydrateSlide(index + 2, 'low');
    };

    const goToSlide = (index) => {
      const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      hydrateSlide(targetIndex, 'high');
      warmSlidesAround(targetIndex);
      currentIndex = targetIndex;

      viewport.scrollTo({
        left: currentIndex * viewport.clientWidth,
        behavior: 'smooth'
      });

      updateButtons();
      updatePagination();
    };

    if (prevButton) {
      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        goToSlide(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        goToSlide(currentIndex + 1);
      });
    }

    viewport.addEventListener(
  'scroll',
  () => {
    if (!viewport.clientWidth) return;

    currentIndex = Math.round(
      viewport.scrollLeft / viewport.clientWidth
    );

    currentIndex = Math.max(
      0,
      Math.min(currentIndex, slides.length - 1)
    );

    // Hydrate the selected slide during native touch scrolling. A single fast
    // swipe can skip past the pointerdown preload window on mobile browsers.
    hydrateSlide(currentIndex, 'high');
    warmSlidesAround(currentIndex);

    updateButtons();
    updatePagination();
  },
  { passive: true }
);

    viewport.addEventListener(
      'pointerdown',
      (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        didDrag = false;
        hydrateSlide(currentIndex - 1, 'low');
        hydrateSlide(currentIndex + 1, 'high');
        hydrateSlide(currentIndex + 2, 'low');
      },
      { passive: true }
    );

    viewport.addEventListener(
      'pointermove',
      (event) => {
        const distanceX = Math.abs(event.clientX - pointerStartX);
        const distanceY = Math.abs(event.clientY - pointerStartY);

        if (distanceX > 8 && distanceX > distanceY) {
          didDrag = true;
        }
      },
      { passive: true }
    );

    viewport.addEventListener('click', (event) => {
      if (!didDrag) return;

      const link = event.target.closest('[data-sango-gallery-link]');

      if (link) {
        event.preventDefault();
        event.stopPropagation();
      }

      didDrag = false;
    });

    window.addEventListener(
      'resize',
      () => {
        viewport.scrollLeft = currentIndex * viewport.clientWidth;
      },
      { passive: true }
    );

    // Preload only the next two shots when a card approaches the viewport.
    // This keeps the carousel instant without downloading every image on the page.
    if ('IntersectionObserver' in window) {
      const warmObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          hydrateSlide(1, 'low');
          hydrateSlide(2, 'low');
          warmObserver.disconnect();
        },
        { rootMargin: '600px 0px' }
      );
      warmObserver.observe(gallery);
    } else {
      hydrateSlide(1, 'low');
    }

    updateButtons();
    updatePagination();
  };

  const initAllGalleries = (root = document) => {
    root
      .querySelectorAll('[data-sango-card-gallery]')
      .forEach(initGallery);
  };

  const start = () => {
    initAllGalleries();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches('[data-sango-card-gallery]')) {
            initGallery(node);
          }

          initAllGalleries(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();